(function () {
  var WORDS = ['hi', 'hola', 'bonjour'];
  var PAUSE = 2400;
  var TRANS = 550;

  function init() {
    var els = document.querySelectorAll('.slideshow .subheading, slide-show .subheading');
    for (var i = 0; i < els.length; i++) setup(els[i]);
  }

  function setup(el) {
    var text = el.textContent;
    var idx = text.toLowerCase().indexOf('hola');
    if (idx === -1) return;

    var before = text.substring(0, idx).replace(/\s+$/, '');
    before = before.replace(/!$/, '');

    var wrapper = document.createElement('span');
    wrapper.className = 'unf-rotator-wrap';

    var line1 = document.createElement('span');
    line1.className = 'unf-rotator-line';
    line1.textContent = before;

    var rotator = document.createElement('span');
    rotator.className = 'unf-rotator';

    for (var w = 0; w < WORDS.length; w++) {
      var span = document.createElement('span');
      span.className = 'unf-rotator__word';
      if (w === 0) span.classList.add('is-active');
      span.textContent = WORDS[w];
      rotator.appendChild(span);
    }

    wrapper.appendChild(line1);
    wrapper.appendChild(rotator);

    el.textContent = '';
    el.appendChild(wrapper);

    var current = 0;
    var wordEls = rotator.querySelectorAll('.unf-rotator__word');

    setInterval(function () {
      var prev = current;
      current = (current + 1) % WORDS.length;
      wordEls[prev].classList.add('is-leaving');
      wordEls[prev].classList.remove('is-active');
      wordEls[current].classList.add('is-active');
      setTimeout(function () {
        wordEls[prev].classList.remove('is-leaving');
      }, TRANS);
    }, PAUSE);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
